const ModeloQuestaoList = () =>
  import("~/components/Views/Prova/ModeloQuestao/List");
const ModeloQuestaoNew = () =>
  import("~/components/Views/Prova/ModeloQuestao/New");

import auth from "~/middleware/auth";
import grupoVerify from "~/middleware/grupoVerify";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "/prova" },
  { name: "Configurações", link: "" }
];

export const modeloQuestao = [
  {
    path: "configuracoes/modelo-questao",
    component: ModeloQuestaoList,
    name: "Modelo de Questão",
    meta: {
      title: "Modelo de Questão",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "configuracoes/modelo-questao/new",
    component: ModeloQuestaoNew,
    name: "Novo Modelo de Questão",
    meta: {
      title: "Novo Modelo de Questão",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "configuracoes/modelo-questao/:id",
    component: ModeloQuestaoNew,
    name: "Alterar Modelo de Questão",
    meta: {
      title: "Alterar Modelo de Questão",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/configuracao/modeloQuestao.js